import { useState, useCallback, useEffect } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import DarkScrollSection from "@/components/DarkScrollSection";
import TicketsSection from "@/components/TicketsSection";
import AnnouncementsSection from "@/components/AnnouncementsSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import Preloader from "@/components/ui/layout-preloader";

const Index = () => {
  const [showPreloader, setShowPreloader] = useState(false);

  useEffect(() => {
    // Check if preloader has been shown before
    const hasSeenPreloader = localStorage.getItem('ayra-preloader-shown');
    if (!hasSeenPreloader) {
      setShowPreloader(true);
    }
  }, []);

  const handleComplete = useCallback(() => {
    setShowPreloader(false);
    // Mark preloader as shown in localStorage
    localStorage.setItem('ayra-preloader-shown', 'true');
  }, []);

  return (
    <>
      {showPreloader && <Preloader onComplete={handleComplete} />}
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <HeroSection preloaderComplete={!showPreloader} />
          <ProblemSection preloaderComplete={!showPreloader} />
          <DarkScrollSection preloaderComplete={!showPreloader} />
          <TicketsSection preloaderComplete={!showPreloader} />
          <AnnouncementsSection preloaderComplete={!showPreloader} />
          <CTASection preloaderComplete={!showPreloader} />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
